import { Link } from "react-router-dom";
import logoAlbaker from "@/assets/logo-albaker.png";

const NotFound = () => (
  <div dir="rtl" className="min-h-screen bg-ink text-bone flex items-center justify-center container-x">
    <div className="text-center">
      <img src={logoAlbaker} alt="Albaker" className="h-14 w-auto mx-auto mb-12 opacity-80" />
      <div className="overline mb-6">404</div>
      <h1 className="font-arabic font-black text-5xl sm:text-7xl text-bone leading-[1.05] mb-6">
        الصفحة غير موجودة
      </h1>
      <p className="text-white/55 font-arabic text-lg mb-12">يبدو أنك وصلت إلى مكانٍ لا نعرفه. لا بأس — رجوعك بسيط.</p>
      <Link to="/" className="btn-gold" data-testid="not-found-home-link">
        <span>العودة للرئيسية</span>
      </Link>
    </div>
  </div>
);

export default NotFound;
